import {Modal} from "react-bootstrap";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {updateEventCoach} from "../redux/pages/event_coaches/actions";
import {useDispatch} from "react-redux";
import {listDashboards} from "../redux/pages/dashboards/actions";

const EditCoachBooking = (props) => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(null);
    const dispatch = useDispatch();

    const handleSubmit = (e) => {
        e.preventDefault();

        const requestBody = { event_coach: { status: status } }

        dispatch(updateEventCoach(requestBody, props.eventCoach.id))
        if(props.dashboard){
            dispatch(listDashboards());
        }
        props.onHide()
    };

    const handleCancel = () => {
        props.onHide()
    }

    return(
        <>
            <Modal show={props.signInModal} onHide={handleCancel}>
                <Modal.Body>
                    <div className="mt-2 mb-4">
                        <h3>{t("confirm_booking_request")}</h3>
                        <h5>
                            {props.getPageTitle}
                        </h5>

                    </div>
                    <form className="ps-3 pe-3" onSubmit={handleSubmit}>

                        <div className="mb-3">
                            <label htmlFor="emailaddress" className="form-label">
                                {t("status")}
                            </label>


                            <select className="form-select"
                                    defaultValue={props.eventCoach?.status}
                                    onChange={event => {
                                        setStatus(event.target.value)
                                    }}
                            >
                                <option value="pending">{t("pending")}</option>
                                <option value="accepted">{t("accepted")}</option>
                                <option value="denied">{t("denied")}</option>
                            </select>
                        </div>

                        <div className="mb-3 text-center">
                            <button onClick={handleCancel} className="btn btn-rounded btn-secondary" type="button">
                                {t("close")}
                            </button>
                            <button className="btn btn-rounded btn-primary"
                                    style={{marginLeft: "5px"}} type="submit">
                                {t("confirm")}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditCoachBooking;